import React, { useMemo } from 'react'

import Header from '../../common/components/Header'
import Select from '../../common/components/Select'
import TextInput from '../../common/components/TextInput'
import TextArea from '../../common/components/TextArea'
import Button, { BUTTON_STYLES } from '../../common/components/Button'

import { useIncidents, useCreateSigEvent } from '../hooks'

import styles from './Form.module.css'

const AddEventForm = () => {
  const [
    { incidentId, subject, description, address, latitude, longitude, error },
    {
      create,
      searchAddress,
      zoomTo,
      setSubject,
      setDescription,
      setIncidentId,
      setAddress,
    },
  ] = useCreateSigEvent()
  const incidents = useIncidents()
  const incidentOptions = useMemo(
    () =>
      incidents
        ? [
            { label: 'Select an Incident', value: -1 },
            ...incidents.map((i) => ({ label: i.name, value: i.id })),
          ]
        : [],
    [incidents]
  )

  const addressSearchButton = useMemo(
    () => ({
      icon: 'fa fa-search',
      onClick: searchAddress,
    }),
    [searchAddress]
  )

  return (
    <div className={styles.container}>
      <Header>Create Significant Event</Header>
      <div>
        <Select
          options={incidentOptions}
          value={incidentId}
          onChange={setIncidentId}
        />
        <TextInput label="Subject" value={subject} onChange={setSubject} />
        <TextInput
          label="Address"
          value={address}
          onChange={setAddress}
          button={addressSearchButton}
        />
        <TextInput
          label="Latitude"
          value={latitude}
          disabled={true}
          className={styles.latLng}
        />
        <TextInput
          label="Longitude"
          value={longitude}
          disabled={true}
          className={styles.latLng}
        />
        <Button
          text={<i className="fas fa-crosshairs fa-2x"></i>}
          style={BUTTON_STYLES.NO_BORDER}
          onClick={zoomTo}
        />
        <TextArea
          label="Description"
          placeholder="Enter description of event."
          rows={10}
          value={description}
          onChange={setDescription}
        />
        {error && <div className={styles.errorMessage}>{error}</div>}
        <Button text="Create" style={BUTTON_STYLES.PRIMARY} onClick={create} />
      </div>
    </div>
  )
}

export default AddEventForm
